import { render, staticRenderFns } from "./DeliveryLogs.vue?vue&type=template&id=3687b4f0&scoped=true"
import script from "./DeliveryLogs.vue?vue&type=script&lang=ts"
export * from "./DeliveryLogs.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryLogs.vue?vue&type=style&index=0&id=3687b4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3687b4f0",
  null
  
)

export default component.exports